<template>
  <div>
    <div class=" mainLoader" v-if="loading">
    </div>
    <div class="realbody">
      <div class="top_summary">
        <div class="container">
          <div class="row">
            <div class="col-md-6 " style="padding: 70px 0px;">
              <p class="top_summary_header mplus2p-m spacing4 noiseblack">{{$t('c_title_recruit')}}</p>
              <p class="top_summary_comment mplus2p-r spacing1-2 noiseblack">{{$t('c_desc_recruit')}}</p>
            </div>
            <div class="col-md-6 " style="text-align: center;">
              <img src="../../assets/imgs/illust-company-section-about.png" class="companyad" />
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row" style="margin-top: 40px;">
          <div class="col-md-3">
            <div class="row">
              <div class="col-md-12 px-0" style="margin-top:0px">
                <div @click="goBack" class="btn w-100 skywhitebtn backbtn mplus2p-r  mb-3 peditboxes">
                  <img style="float: left; margin-top: 2px;" src="../../assets/imgs/backarrow.png" />
                    <span style="margin-left:-50px">
                    {{$t('chat_back')}}
                    </span>
                </div>
              </div>
                 <v-popover
                  placement="top"
                  offset="0"
                  >
                    <span class="tooltip-target">
                     <i class="fa fa-info-circle" ></i></span>
                    <template slot="popover">
                      <p style="padding:0 10px">{{ $t('tooltip_en_desc1') }}</p>
                      <p>{{ $t('tooltip_en_desc2') }} <span style="color:#3d7dd8;font-weight:700">Java+PHP</span> {{ $t('tooltip_en_desc3') }} <span style="color:#3d7dd8;font-weight:700">Java PHP</span> </p>
                    </template>
                  </v-popover>
              <div class="col-md-12 px-0" style="margin-top: 10px;">
                <div class="input-group mb-3  peditboxes">
                  <input  v-model="searchCompany" type="text" class="form-control" style="height:44px" :placeholder="$t('c_search_keyword')" aria-label="Recipient's username" aria-describedby="basic-addon2">
                  <div class="input-group-append">
                    <button @click="filterRecruits(page)" class="btn btn-outline-secondary" type="button">
                      <i class="fa fa-search" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="window_width <= (768-17)" class="col-md-12" @click="clicked_moreoption">
                <div class="mmenu_item" id="more_option">
                  <span class="mmenu_item_txt mplus2p-m spacing1-2">View Option</span>
                  <span class="mmenu_item_arrow mplus2p-m spacing1-2">
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
              <div class="col-md-12 checkgrouppanel " data-target="#company_established" data-toggle="collapse" aria-expanded="false">
                <span data-target="#company_established" data-toggle="collapse" aria-expanded="false" class="checkgrouplabel mplus2p-m spacing1-2 noiseblack">
                    <i class="fa fa-history fa-lg"></i> {{$t('company_established')}}
                  <span class="dropdown-toggle text-left"></span>
                </span>
                <ul class="cline collapse list-unstyled mt-3" id="company_established">
                  <li v-for="(establish,index) of company_established" :key="index" v-on:click.stop>
                    <div class="custom-control custom-radio">
                      <input type="radio" name="customRadio"  @change="filterRecruits(page)" v-model="company_establishe" :id="establish.id" :value="establish.id" class="custom-control-input">
                      <label v-if="lan == 'en'" class="custom-control-label" :for="establish.id">{{establish.en_year}}</label>
                      <label v-else class="custom-control-label" :for="establish.id">{{establish.jp_year}}</label>
                    </div>
                  </li>

                </ul>
              </div>
              <div class="col-md-12 checkgrouppanel " data-target="#recruitmentSituation" data-toggle="collapse" aria-expanded="false">
                <span data-target="#recruitmentSituation" data-toggle="collapse" aria-expanded="false" class="checkgrouplabel mplus2p-m spacing1-2 noiseblack">
                    <i class="fa fa-check-circle-o fa-lg"></i> {{$t('recruitment_situation')}}
                  <span class="dropdown-toggle text-left"></span>
                </span>
                <ul class=" cline collapse list-unstyled mt-3" id="recruitmentSituation">
                  <li v-for="(recruitment,index) of recruitment_situation" :key="index" v-on:click.stop>
                    <label :for="'recruitment'+recruitment.id" class="custom-control material-checkbox">
                      <input type="checkbox" class="material-control-input" @click="filterRecruits(page)" v-model="recruitment.isChecked" :id="'recruitment'+recruitment.id" :value="recruitment.id">
                      <span class="material-control-indicator"></span>
                      <span class="material-control-description">{{lan == 'en' ? recruitment.en_situation : recruitment.jp_situation}}</span>
                    </label>
                  </li>

                </ul>
              </div>

              <div class="col-md-12 checkgrouppanel options" data-target="#benefit" data-toggle="collapse" aria-expanded="false">
                <span data-target="#benefit" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle checkgrouplabel mplus2p-m spacing1-2 noiseblack">
                    <i class="fa fa-bold fa-lg"></i> {{$t('benefit')}}
                </span>
                <ul class="cline collapse list-unstyled mt-3" id="benefit">
                  <li v-for="(benefit,index) of benifitsCompany" :key="index" v-on:click.stop>
                    <label :for="'benefit'+benefit.id" class="custom-control material-checkbox">
                      <input type="checkbox" class="material-control-input" @click="filterRecruits(page)" v-model="benefit.isChecked" :id="'benefit'+benefit.id" :value="benefit.id">
                      <span class="material-control-indicator"></span>
                      <span class="material-control-description">{{lan == 'en' ? benefit.en_benefit : benefit.jp_benefit}}</span>
                    </label>
                  </li>
                </ul>
              </div>

              <div class="col-md-12 checkgrouppanel options" data-target="#ratio_of_engineer" data-toggle="collapse" aria-expanded="false">
                <span data-target="#ratio_of_engineer" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle checkgrouplabel mplus2p-m spacing1-2 noiseblack">
                    <i class="fa fa-line-chart fa-lg"></i> {{$t('ratio_of_engineer')}}
                </span>
                <ul class="cline collapse list-unstyled mt-3" id="ratio_of_engineer">
                  <li v-for="(ratio_of_engineer,index) of ratioOfEngineers" :key="index" v-on:click.stop>
                    <div class="custom-control custom-radio">
                      <input type="radio" name="customRadio2"  @change="filterRecruits(page)" v-model="ratioOfEngineer" :id="'customRadio2'+ratio_of_engineer.id" :value="ratio_of_engineer.id" class="custom-control-input">
                      <label v-if="lan == 'en'" class="custom-control-label" :for="'customRadio2'+ratio_of_engineer.id">{{ratio_of_engineer.en_ratio}}</label>
                      <label v-else class="custom-control-label" :for="'customRadio2'+ratio_of_engineer.id">{{ratio_of_engineer.jp_ratio}}</label>
                    </div>
                  </li>
                </ul>
              </div>


              <div class="col-md-12 checkgrouppanel options" data-target="#contract" data-toggle="collapse" aria-expanded="false">
                <span data-target="#contract" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle checkgrouplabel mplus2p-m spacing1-2 noiseblack">
                    <i class="fa fa-file-text-o fa-lg"></i> {{$t('contract')}}
                </span>
                <ul class="cline collapse list-unstyled mt-3" id="contract">
                  <li v-for="(contract,index) of typeOfContracts" :key="index" v-on:click.stop>
                    <label :for="'contract'+contract.id" class="custom-control material-checkbox">
                      <input type="checkbox" class="material-control-input" @click="filterRecruits(page)" v-model="contract.isChecked" :id="'contract'+contract.id" :value="contract.id">
                      <span class="material-control-indicator"></span>
                      <span class="material-control-description">{{lan == 'en' ? contract.en_type : contract.jp_type}}</span>
                    </label>
                  </li>
                </ul>
              </div>

            </div>

          </div>
          <div class="col-md-9">
            <div class="page_title">
              <span class="page_title_comment mplus2p-m spacing1-2 noiseblack">{{$t('recruit_list')}}</span>
            </div>
             <div class="row companyview-topoptions">
              <div class="col-md-4" style="margin-top:35px">
                <div class="selectdiv peselectboxs form-group" style="min-width: 330px;">
                  <select class="form-control" v-model="sortRecruit" @change="filterRecruits(page)">
                    <option class="checklabel mplus2p-m spacing1-2 noiseblack" value="">{{$t('recruit_sort_1')}}</option>
                    <option class="checklabel mplus2p-m spacing1-2 noiseblack" value="Newest order of last update date">{{$t('recruit_sort_2')}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div v-if="recruit_list == ''" class="row companyviews">
              <div class="col-md-12 ceboxes">
                <div class="alert alert-danger text-center">
                  <strong>{{$t('err_recruitAvailable')}}</strong>
                </div>
              </div>
            </div>
            <div v-else class="row companyviews" v-for="(recruit,index) of recruit_list" :key="index">
              <div class="col-md-12 ceboxes">
                <div class="row">
                  <div class="col-md-2" style="text-align: center;">
                    <div class="imgpanel mb-1">
                      <video v-if="recruit.company.video"   height="135" width="135" controls autoplay loop>
                        <source :src="recruit.company.video">
                      </video>
                      <img v-if="recruit.company.image" class="c_images" :src="recruit.company.image" />
                    </div>
                  </div>
                  <div class="col-md-10" style="text-align: left;">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-7">
                              <p class="ctitle mplus2p-r spacing1-2 noiseblack companyDetailPointer" @click="companyDetails(recruit.company.id)">{{recruit.company.name}} </p>
                          </div>
                          <div class="col-md-5">
                            <div class="row">
                              <div class="col-md-12 mplus2p-m spacing1-2 ">
                                <div class="ctitlecomment " v-if="interview_completed">
                                    <span class="blue" style="float : right;">
                                        <button class="btn clickcbtn whitebtn"  @click="andMore(recruit.id)">
                                          <span class="cstitle mplus2p-m spacing1-2">
                                            <span class="cplus">+</span>&nbsp;{{$t('c_andmore')}}</span>
                                        </button>
                                        <button v-if="!testUser" class="btn whitebtn clickcbtn" :class="{like : recruit.favorited }"  @click="onFavClick(recruit.id,index)" style="margin-right: 10px;">
                                          <i class="fa fa-heart margin-r-5"></i>
                                        </button>
                                        <button v-if="!testUser && recruit.company.users_count > 0" class="btn whitebtn clickcbtn"  @click="sandMsg(recruit.company_id)" style="margin-right: 10px;">
                                        <i class="fa fa-envelope margin-r-5"></i>
                                      </button>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <p class="ctitle2 mplus2p-r spacing1-2 noiseblack">{{recruit.subject}} </p>
                          <p class="ccontents mplus2p-r spacing1-2 noiseblack" style="height: auto;white-space:pre-wrap;-webkit-box-orient: vertical">{{recruit.content}}
                          </p>
                          <div class="tech2">
                            <span class="layer2" v-for="(item, index) of recruit.contract_types" :key="index">{{lan == 'en' ? item.en_type : item.jp_type}}</span>
                          </div>
                          <div class="tech">
                            <span class="layer" v-for="(item, index) of recruit.skill_keyword" :key="index">{{lan == 'en' ? item.check_content : item.jp_check_content}}</span>
                          </div>
                          <div v-if="recruit.manager_comments" class="comment-block">
                              <p class="comment-title">{{$t('comments_manager')}}</p>
                              <p class="comment-desc">{{recruit.manager_comments}}</p>
                          </div>

                      </div>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
            <div v-if="recruit_list != '' && totalPage != 1" style="margin-right: -30px;" class="pagination justify-content-end mt-2">
              <vue-pagination :total="totalPage" v-model="page" @input="nextPage"></vue-pagination>
            </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import moment from 'moment';
import Hashids from "hashids";
import axios from "axios";
import e_engineer_sidenav from "./e_engineer_sidenav";
import { EventBus } from "../../main.js";

export default {
  data() {
    return {
      message: "Tooltip Description",
      selectedItem: 42,
      searchCompany: '',
      title: "",
      testUser: 0,
      company_establishe: '',
      company_established: [],
      recruitment_situation: [],

      interview_completed: '',

      benifitsCompany: [],

      ratioOfEngineer: '',
      ratioOfEngineers: [],

      typeOfContracts: [],


      loading: false,
      window_width: "",
      recruit_list: [],
      company_favorite: [],
      role: "",
      lan: "jp",
      userId: "",
      userToken: "",
      job_seeking: [],

      page: 1,
      currentPage: "",
      totalPage: 1,

      popupDisplay : false,

      filterCompany: 0,

      image: null,
      record: "",
      show: false,
      sortRecruit: ''
    };
  },
  mounted() {
    EventBus.$on("language", data => {
      this.lan = data;
    });
    if ("lan" in localStorage) {
      this.lan = localStorage.getItem("lan");
    }
    if (localStorage.getItem("role") == "engineer") {
      var retrievedData = localStorage.getItem("user");
      var data = JSON.parse(retrievedData);
      this.userId = data.id;
      this.userToken = data.user_token;
      this.testUser = data.test_user;
      this.interview_completed = data.completed_interview;
      this.job_seeking = data.job_seeking_situation;
    }
    this.page = parseInt(this.$route.query.page);
    this.window_width = $(window).width() + 17; //default
    this.showorhide();

    this.getRecruitList(this.$route.query.page);
    this.getEstablishmentYear();
    this.getRatioOfEngineers();
    this.getBenefits();
    this.getRecruitmentSituation();
    this.getTypeOfContract();
  },
  created() {
     this.role = localStorage.getItem("role");
  },
  watch: {
    $route(to, from) {
      if (this.filterCompany == 1) {
          this.filterRecruits(this.$route.query.page);
      }
      else {
        this.getRecruitList(this.$route.query.page);
      }
    }
  },
  components: {
    appEEngineerSidenav: e_engineer_sidenav
  },
  computed: {
    onResize(event) {
      this.window_width = $(window).width() + 17;
      this.showorhide();
      this.getRecruitList(this.$route.query.page);

    }
  },
  methods: {
    andMore(id){
      let routeData =  this.$router.resolve({
        name: "companyRecuritDetail",
        params: { rid: id},
      });
      window.open(routeData.href, '_blank');
    },
    newCompany(data){
      // var a = moment();
      // var b = moment(data.created_at);
      // var result = moment().diff(b,'days');
      // if (moment().diff(moment(data.created_at),'days') < 30) {
      //   return true;
      // }
      // return false;
      return moment().diff(moment(data.created_at),'days') < 30 ?  true :  false;

    },
    showorhide() {
      if (this.window_width > 768) {
        $(".options").removeClass("hider");
        $(".options").addClass("show");
      }
      if (this.window_width <= 768) {
        $(".options").removeClass("show");
        $(".options").addClass("hider");
      }
    },
    clicked_moreoption() {
      if ($(".options").hasClass("hider")) {
        $(".options").removeClass("hider");
        $(".options").addClass("show");
      } else {
        $(".options").removeClass("show");
        $(".options").addClass("hider");
      }
    },
    prevPage() {
      if (this.page == 1) return;
      --this.page;
      if (this.filterCompany) {
          this.filterRecruits();
      } else {
        this.getRecruitList();
      }
    },
    nextPage(value) {
      if (this.totalPage < this.page) return;
      if (this.filterCompany == 1) {
        this.filterRecruits(value)
      }
      else {
        this.getRecruitList(value);
      }
    },
    getRecruitmentSituation(){
        axios
        .get("/recruitment-situation")
        .then(res => {
          if (res.data.situations) {
            this.recruitment_situation = res.data.situations.filter(obj => obj.id != 2);
          }
        })
        .catch(error => console.log(error));
    },
    getTypeOfContract() {
      axios
        .get("/contract-types")
        .then(res => {
          this.typeOfContracts = res.data.types;
        })
        .catch(error => console.log(error));
    },
    getBenefits() {
      axios
        .get("/benefits")
        .then(res => {
          this.benifitsCompany = res.data.benefits;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getEstablishmentYear() {
      axios
        .get("/establishment-years")
        .then(res => {
          this.company_established = res.data.years;
          var established =
            {
                created_at: "2018-10-05 06:10:20",
                en_year: "all",
                id: 'all',
                jp_year: "全て",
                updated_at: "2018-10-05 06:10:20"
              };
              if (this.company_established ) {
                this.company_established.splice(0, 1, established)
              }
        })
        .catch(error => console.log(error));
    },
    getRatioOfEngineers() {
      axios
        .get("/ratio-of-engineer")
        .then(res => {
          this.ratioOfEngineers = res.data.ratios;
          var ratio =
            {
                created_at: "2018-10-05 06:10:20",
                en_ratio: "all",
                id: 'all',
                jp_ratio: "全て",
                updated_at: "2018-10-05 06:10:20"
              };
               if (this.ratioOfEngineers) {
                  this.ratioOfEngineers.splice(0, 1, ratio)
               }
        })
        .catch(error => console.log(error));
    },
    onFavClick(id, index) {
      var token = localStorage.getItem("token");
      var vm = this;
      const formData = {
        recruit_id: id
      };
      this.$forceUpdate();
      axios
        .post("/favorite/recruit?token=" + token, formData, {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (!res.data.result) {
            if (res.data.data.message) {
              this.$toaster.error(res.data.data.message);
              this.$forceUpdate();
            }
          } else {
            if (res.data.liked) {
              this.$toaster.success(vm.$t("success_recruit_favorited"));
            } else {
              this.$toaster.error(vm.$t("err_recruit_favorited"));
            }
            this.getRecruitList(this.$route.query.page);
          }
        });
    },
    cPage(currentPage) {
      this.$router.push({ query: { page: currentPage } });
    },
    filterRecruits(page) {
      this.loading = true;
      var recruitment_situation_id = '';
      setTimeout(() => {
        for (var i = 0; i < this.recruitment_situation.length; i++) {
          if (this.recruitment_situation[i].isChecked) {
            recruitment_situation_id = this.recruitment_situation[i].id;
          }
        }
      }, 1000);

      var contract_type_id = [];
      setTimeout(() => {
        for (var i = 0; i < this.typeOfContracts.length; i++) {
          if (this.typeOfContracts[i].isChecked) {
            contract_type_id.push(this.typeOfContracts[i].id);
          }
        }
      }, 1000);

      var benefits = [];

      setTimeout(() => {
        for (var i = 0; i < this.benifitsCompany.length; i++) {
          if (this.benifitsCompany[i].isChecked) {
            benefits.push(this.benifitsCompany[i].id);
          }
        }
      }, 1000);

      const formData = {};
      setTimeout(() => {
        if (benefits.length > 0) {
          formData["benefits"] = benefits;
        }

        if(this.company_establishe != '')
        {
          formData["establishment_year"] = this.company_establishe;
        }
        if (recruitment_situation_id.length != '') {
          formData["recruitment_situation"] = recruitment_situation_id;
        }
        if (this.ratioOfEngineer != '') {
          formData["ratio_id"] = this.ratioOfEngineer;
        }
        if (contract_type_id.length > 0) {
          formData["contract_type_id"] = contract_type_id;
        }
        formData["input"] = this.searchCompany
        formData["sort"] = this.sortRecruit
        this.filterCompany = 1;
        if (page > 1) {
          page = page;
        }
        if (page < 1) {
          page = this.$route.query.page;
        }
        axios
          .post(
            "/recruit-filter?page=" + page + "&token=" + localStorage.getItem("token"),
            formData
          )
          .then(res => {
            if (!res.data.result) {
              if (res.data[0]) {
                this.$toaster.error(res.data[0]);
                this.$store.dispatch("logout");
              }
              this.loading = false;
            } else {
              this.loading = false;
              for (let index = 0; index < res.data.recruits.data.length; index++) {
                if (res.data.recruits.data[index].company.image.split(/\#|\?/)[0].split('.').pop().trim() === 'mp4') {
                res.data.recruits.data[index].company.video = res.data.recruits.data[index].company.image
                res.data.recruits.data[index].company.image = ""
                }else{
                  res.data.recruits.data[index].company.image = res.data.recruits.data[index].company.image
                }
              }
              this.recruit_list = res.data.recruits.data;
              this.totalPage = res.data.recruits.last_page;
              this.currentPage = res.data.recruits.current_page;
              this.cPage(this.currentPage);
              this.page = res.data.recruits.current_page;
            }
          })
          .catch(error => console.log(error));
      }, 1000);
    },
    getRecruitList(page) {
      if (page > 1) {
        page = page;
      }
      if (page < 1) {
        page = this.$route.query.page;
      }
      this.loading = true;
      this.filterCompany = 0;
      var token = localStorage.getItem("token");
      axios
        .get("/recruit/list?page=" + page+ "&token=" + token, {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (!res.data.result) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
            this.loading = false;
          } else {
            this.loading = false;
            for (let index = 0; index < res.data.recruits.data.length; index++) {
               if (res.data.recruits.data[index].company.image.split(/\#|\?/)[0].split('.').pop().trim() === 'mp4') {
               res.data.recruits.data[index].company.video = res.data.recruits.data[index].company.image
               res.data.recruits.data[index].company.image = ""
              }else{
                res.data.recruits.data[index].company.image = res.data.recruits.data[index].company.image
              }
            }
            this.recruit_list = res.data.recruits.data;
            this.totalPage = res.data.recruits.last_page;
            this.currentPage = res.data.recruits.current_page;
            this.cPage(this.currentPage);
            this.page = res.data.recruits.current_page;
          }
        })
        .catch(error => console.log(error));

    },
    sandMsg(cid) {
      var hashids = new Hashids("this is my salt", 8, "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890");
      this.$router.push("/global/chatroom/"+ hashids.encode(cid));
    },
    companyDetails(cid){
       var hashids = new Hashids(
        "CompanyIds",
        8,
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890"
      );
     let routeData =  this.$router.resolve({
            name: "companyDetail",
            params: { cid: hashids.encode(cid)},
          });
      window.open(routeData.href, '_blank');
    },
    goBack() {
      var retrievedData = localStorage.getItem("user");
      var data = JSON.parse(retrievedData);
      var userToken = data.user_token;
      this.$router.push("/engineer/profile/" + userToken);
    }
  }
};
</script>

<style scoped>
.like .fa {
  color: #fc033b;
  text-shadow: 1px 1px 1px #ccc;
}
.comment-block{
  border: 2px solid #3f7ed8;
 padding: 10px 25px 10px 25px;
  border-radius: 20px;
}
.comment-title{
  color: #3f7ed8;
  font-size: 1.2rem;
  text-decoration: underline;
}
.comment-desc{
  white-space: pre-line;
  word-break: break-all;
  font-size: 1rem;
  margin: 0;
  color: #3f7ed8;
}
.tech2 {
  margin-right: 5px;
}

.layer2 {
  font-size: 1rem;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 1.4px;
  color: #fff;
  background-color: #999999;
  padding: 5px;
  margin-right: 5px;
  white-space: pre;
  word-break: keep-all;
  display: inline-block;
  border-radius: 5px;
  margin-bottom: 10px;
}
.tech {
  margin-right: 5px;
  margin-bottom: 10px;
}

.layer {
  border: 2px solid #999999;
  font-size: 1rem;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 1.4px;
  color: #999999;
  background-color: #fff;
  padding: 5px;
  margin-right: 5px;
  white-space: pre;
  word-break: keep-all;
  display: inline-block;
  border-radius: 5px;
  margin-bottom: 10px;
}
.imgpanel {
  text-align: center;
  margin: auto;
}
.cline {
  border:2px solid  #e6e8ea;
  margin-top: 15px;
  margin-bottom: 15px;
}
.custom-control.material-checkbox {
  --color: #3d7dd8;
}
.custom-radio .custom-control-input:checked~.custom-control-label::before {
    background-color: #3d7dd8;
}
.custom-control-input:checked~.custom-control-label::before {
    color: #fff;
    background-color: #3d7dd8;
}
.custom-control.material-checkbox .material-control-input {
  display: none;
}

.custom-control.material-checkbox
  .material-control-input:checked
  ~ .material-control-indicator {
  border-color: var(--color);
  -webkit-transform: rotateZ(45deg) translate(1px, -5px);
  transform: rotateZ(45deg) translate(1px, -5px);
  width: 10px;
  border-top: 0px solid #fff;
  border-left: 0px solid #fff;
}

.custom-control.material-checkbox .material-control-indicator {
  display: inline-block;
  position: absolute;
  top: 4px;
  left: 0;
  width: 16px;
  height: 16px;
  border: 2px solid #aaa;
  transition: 0.3s;
}

a {
  color: #3c5064;
}
.companyDetailPointer:hover{
  cursor: pointer;
  text-decoration: underline;
}
.companyad {
  width: 95%;
  margin-top: 5px;
}

.leftad {
  padding: 50px 20px;
}

.rightad {
  text-align: center;
  padding: 5px 0px;
}

.slide_options {
  background-color: #f8fafa;
  border-radius: 30px;
  margin: 10px 0px;
  margin-top: 44px;
  padding: 5px 0px;
}

.slide_item {
  text-align: center;
  padding: 18px;
  cursor: pointer;
}

.spressed {
  text-align: center;
  padding: 18px;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
}
.ctitlecomment {
  font-size: 0.75rem;
  font-weight: 500;
  margin-top: 5px;
}

.slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #b4bec8;
}

.spressed .slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #3d7dd8;
}

.filterSpinner {
  color: #3d7dd8;
}

.pview {
  margin-top: 38.5px;
  margin-bottom: 80px;
}

.avatar {
  width: 80%;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

.cs_summary {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  margin-top: 21px;
}

.pvlabel {
  margin-left: 20px;
}

.pv_btnpanel {
  padding: 0px 10%;
}

.updatebtn {
  width: 100%;
  height: 56px;
}

.pv_showchart {
  background-color: #f8f8fa;
  margin-top: 16px;
}

.eview {
  padding: 30px 15px;
}

.chartboxes {
  display: block;
  margin: auto;
  margin-bottom: 30px;
  max-width: 200px;
  height: 100px;
}

.statustitle {
  font-size: 1.25rem;
  font-weight: bold;
  margin-top: 34px;
  margin-bottom: 0.1rem;
}

.statusnum {
  position: absolute;
  font-weight: bold;
  font-size: 1.5rem;
}

.caltxt {
  margin-top: 45px;
}

.calpanel {
  text-align: right;
}

.searchbox {
  height: 40px;
  border-radius: 4px;
  background-color: #f0f2f4;
  border: 1px solid #58606800;
}

.input-group-append {
  border-top-right-radius: 6.4px;
  border-bottom-right-radius: 6.4px;
  background-color: #3d7dd8;
}

.input-group-append button {
  color: white;
  border: 1px solid #58606800;
}

.input-group-append:hover button {
  color: #3d7dd8 !important;
}

.btn-outline-secondary:hover {
  background-color: white;
  color: #3d7dd8 !important;
}
.backbtn {
    border-radius: 8px;
    margin-top: 10px;
    padding: 10px 15px;
    font-weight: bold;
}

.extxt {
  font-size: 0.75rem;
  font-weight: 500;
  color: rgba(60, 80, 100, 0.8);
}

.checklabel {
  font-size: 0.8125rem;
  font-weight: 500;
}

.styled-checkbox + label:before {
  margin-right: 12px;
  margin-top: -2px;
}

.checkgrouplabel {
  font-size: 0.8125rem;
  font-weight: 500;
  color: #3c5064;
}
.checkgrouppanel {
  width: 100%;
  border-radius: 4px;
  padding: 13px 15px;
  background-color: white;
  border: solid 1px #e6e8ea;
  margin-top: 8px;
  cursor: pointer;
}
.checkgrouppanelbtn {
  width: 100%;
  border-radius: 4px;
  background-color: white;
  border: solid 1px #e6e8ea;
  cursor: pointer;
}

.unstyled {
  margin-top: 13px;
}

.unstyled li {
  margin-top: 1px;
}
span[data-toggle="collapse"] {
  position: relative;
}

.dropdown-toggle::after {
  display: block;
  margin-top: 10px;
  float: right;
  transform: translateY(-50%);
}
.custom-control {
  position: relative;
  display: block;
  min-height: 0.5rem;
  padding-left: 1.5rem;
  margin-top: 10px;
  margin-left: 10px;
  padding-bottom: 10px;
}
.companyview-topoptions {
  padding: 10px 15px;
  margin-top: 10px;
}

.companyview-topoptions .col-md-3 {
  padding: 0;
}

.companyview-topoptions .col-md-9 {
  padding: 0;
}

.selectdiv:after {
  content: "\f107";
  color: #6474847d;
  top: 3px;
}

.selectdiv select {
  height: 44px;
}

.rtoptions {
  margin-top: 14px;
  float: left;
  margin-left: 40px;
}

.ceboxes {
  margin: 16px;
  margin-top: 10px;
  margin-bottom: 0px;
  text-align: center;
}

.ceboxes2 {
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 4px 0 rgba(60, 80, 100, 0.12);
  box-shadow: 0 1px 4px 0 rgba(60, 80, 100, 0.12);
  background-color: #ffffff;
  border: solid 1px #e8eaee;
  padding: 14px 16px;
}

#pointer {
  width: 59.7px;
  height: 24px;
  background: #3d7dd8;
  box-shadow: 0 1px 2px 0 rgba(60, 80, 100, 0.12);
  position: absolute;
  z-index: 1;
  left: 0;
  top: 7px;
}

#pointer:after {
  content: "";
  position: absolute;
  right: -12px;
  bottom: 0;
  width: 0;
  height: 0;
  border-right: 12px solid transparent;
  border-top: 12px solid #3d7dd8;
  border-bottom: 12px solid transparent;
}

#pointer:before {
  content: "";
  position: absolute;
  right: -12px;
  bottom: 0;
  width: 0;
  height: 0;
  border-left: 12px solid #3d7dd8;
  border-top: 12px solid transparent;
}

.newtag {
  font-size: 0.6875rem;
  font-weight: bold;
  color: white;
}
.imgpanel{
  height: 210px;
}
.c_images {
  /* margin-top: 40px;
  width: 147px;
  height: 147px;
  object-fit: contain;
  object-position:center; */

  width: 100%;
  margin-top: 20px;
  object-fit: cover;
  object-position:center;
}
.ctitle{
  font-size: 0.8rem;
   display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
   text-overflow: ellipsis;
  word-wrap: break-word;
  margin: 0;
  padding: 0;
  margin-top: 25px;
  color: rgb(116, 192, 218);
  font-weight: 600;
}
.ctitle2 {
  margin-bottom: 7px;
  font-size: 1.3em;
 -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  word-wrap: break-word;
  text-align: justify;
}
/* .ctitle2{

    margin-top: 7px;
} */
.ccontents {
  font-size: 1rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-align: justify;
   text-overflow: ellipsis;
   word-wrap: break-word;
}
.ccontents2 {
  font-size: 0.625rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-align: justify;
  word-wrap: break-word;
}

.cline {
  border:1px solid #e6e8ea;
}

.cstitle {
  font-size: 0.8125rem;
  font-weight: 500;
}

.clickcbtn {
  border-radius: 20px;
  padding: 7px 14px;
  box-shadow: 0 1px 4px 0 rgba(40, 60, 80, 0.4);
  float: right;
}
.clickcbtn {
  border-radius: 20px;
  padding: 7px 14px;
  box-shadow: 0 1px 4px 0 rgba(40, 60, 80, 0.4);
  float: right;
}

.cplus {
  font-size: 1.5em;
  line-height: 1;
}

.skillsets {
  text-align: left;
  padding: 9px 10px;
}


@media screen and (max-width: 992px) {
  .rightad {
    padding: 50px 0px;
  }
}

@media screen and (max-width: 768px) {
  .avatar {
    width: 50%;
  }

  .page_title {
    margin-top: 40px;
  }

  .pvlabel {
    margin-left: 0px;
  }

  .calpanel {
    text-align: center;
  }

  .rightad {
    padding: 0px 10px;
  }

  .leftad {
    padding: 20px 10px;
  }

  .rtoptions {
    margin-top: 14px;
    float: none;
    margin-left: 0px;
  }

  .skillsets {
    padding: 0;
    margin-top: 20px;
  }

  .ceboxes .col-md-3 {
    margin-bottom: 30px;
  }

  .c_images {
    width: 144px;
  }
}
</style>
